// extracted by mini-css-extract-plugin
export default {"cardContainer":"dream_cardContainer__NWzGI","showCard":"dream_showCard__tpAFF","editStyle":"dream_editStyle__kYA5I","font20":"dream_font20__YweFm"};